import React from "react";

import {
  PlusCircle,
  DotsIcon,
  EditIcon,
  DeleteIcon,
  PlusIcon,
  UserIcon,
  CloseIcon,
  ListIcon,
  SearchIcon,
  ShareIcon,
  CircleFillIcon,
  CircleIcon,
  CircleIcon2,
  TrashIcon,
  MinusIcon,
  SunIcon,
  MoonIcon,
  GridIcon,
  BellIcon,
  PhoneIcon1,
  PhoneIcon2,
  HomeIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowTopIcon,
  ArrowBottomIcon,
  ArrowRightIcon1,
  ArrowLeftIcon1,
  TickIcon,
  SettingIcon,
  ManagerIcon,
  PlusSquareIcon,
  StepIcon,
  EyeIcon,
  EnvelopeIcon,ForbiddenIcon
} from "../components/kits/Icons";

const divStyle: React.CSSProperties = {
  border: "1px solid black",
  padding: 20
}

const IconsPage: React.FC = () => {
  return (
    <div
      className="row row-cols-2 row-cols-md-4 row-cols-lg-5 row-cols-xl-6"
      style={{
        width: "100vw",
        height: "100vh",
        padding: "100px 50px"
      }}
    >
      <div style={divStyle}>
        PlusCircle <PlusCircle />
      </div>
      <div style={divStyle}>
        DotsIcon <DotsIcon />
      </div>
      <div style={divStyle}>
        EditIcon <EditIcon />
      </div>
      <div style={divStyle}>
        DeleteIcon <DeleteIcon />
      </div>
      <div style={divStyle}>
        PlusIcon <PlusIcon />
      </div>
      <div style={divStyle}>
        UserIcon <UserIcon />
      </div>
      <div style={divStyle}>
        CloseIcon <CloseIcon />
      </div>
      <div style={divStyle}>
        ListIcon <ListIcon />
      </div>
      <div style={divStyle}>
        SearchIcon <SearchIcon />
      </div>
      <div style={divStyle}>
        ShareIcon <ShareIcon />
      </div>
      <div style={divStyle}>
        CircleFillIcon <CircleFillIcon />
      </div>
      <div style={divStyle}>
        CircleIcon <CircleIcon />
      </div>
      <div style={divStyle}>
        CircleIcon2 <CircleIcon2 />
      </div>
      <div style={divStyle}>
        TrashIcon <TrashIcon />
      </div>
      <div style={divStyle}>
        MinusIcon <MinusIcon />
      </div>
      <div style={divStyle}>
        SunIcon <SunIcon />
      </div>
      <div style={divStyle}>
        MoonIcon <MoonIcon />
      </div>
      <div style={divStyle}>
        GridIcon <GridIcon />
      </div>
      <div style={divStyle}>
        BellIcon <BellIcon />
      </div>
      <div style={divStyle}>
        PhoneIcon1 <PhoneIcon1 />
      </div>
      <div style={divStyle}>
        PhoneIcon2 <PhoneIcon2 />
      </div>
      <div style={divStyle}>
        HomeIcon <HomeIcon />
      </div>
      <div style={divStyle}>
        ArrowLeftIcon <ArrowLeftIcon />
      </div>
      <div style={divStyle}>
        ArrowRightIcon <ArrowRightIcon />
      </div>
      <div style={divStyle}>
        ArrowTopIcon <ArrowTopIcon />
      </div>
      <div style={divStyle}>
        ArrowBottomIcon <ArrowBottomIcon />
      </div>
      <div style={divStyle}>
        ArrowRightIcon1 <ArrowRightIcon1 />
      </div>
      <div style={divStyle}>
        ArrowLeftIcon1 <ArrowLeftIcon1 />
      </div>
      <div style={divStyle}>
        TickIcon <TickIcon />
      </div>
      <div style={divStyle}>
        SettingIcon <SettingIcon />
      </div>
      <div style={divStyle}>
        ManagerIcon <ManagerIcon />
      </div>
      <div style={divStyle}>
        PlusSquareIcon <PlusSquareIcon />
      </div>
      <div style={divStyle}>
        StepIcon <StepIcon />
      </div>
      <div style={divStyle}>
        EyeIcon <EyeIcon />
      </div>
      <div style={divStyle}>
        EnvelopeIcon <EnvelopeIcon />
      </div>
      <div style={divStyle}>
        ForbiddenIcon <ForbiddenIcon />
      </div>
    </div>
  );
};

export default IconsPage;
